/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestion_FloorsInputs */

const en_chat_suggestion_floors = /** @type {(inputs: Chat_Suggestion_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patrol all floors`)
};

const fr_chat_suggestion_floors = /** @type {(inputs: Chat_Suggestion_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patrol sur tous les étages`)
};

const ms_sg2_chat_suggestion_floors = /** @type {(inputs: Chat_Suggestion_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rondaan di semua tingkat`)
};

/**
* | output |
* | --- |
* | "Patrol all floors" |
*
* @param {Chat_Suggestion_FloorsInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_suggestion_floors = /** @type {((inputs?: Chat_Suggestion_FloorsInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestion_FloorsInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_suggestion_floors(inputs)
	if (locale === "fr") return fr_chat_suggestion_floors(inputs)
	return ms_sg2_chat_suggestion_floors(inputs)
});